// extracted by mini-css-extract-plugin
var _1 = "FormActionsAttachContainer-modulecontainerDragging__RJfNl";
var _2 = "FormActionsAttachContainer-moduledragging__oPNC3";
var _3 = "FormActionsAttachContainer-moduledraggingWrapper__UmUSq";
var _4 = "FormActionsAttachContainer-moduleover__CIr9m";
var _5 = "FormActionsAttachContainer-moduletext__cz3d8";
export { _1 as "containerDragging", _2 as "dragging", _3 as "draggingWrapper", _4 as "over", _5 as "text" }
